// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__UYsO_","popperHost":"App_popperHost__v1S62","spinner":"App_spinner__Os7jH"};